<template>
	<article>
		<ManagingSection>
			<ManagingBox :no-header="true" :no-padding="true">
				<Chart ref="chart" :options="chartOptions"></Chart>
			</ManagingBox>
		</ManagingSection>
	</article>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import HighChart from 'highcharts';
	import HighChart3D from 'highcharts/highcharts-3d';
	import HighChartExporting from 'highcharts/modules/exporting';
	import { Chart } from 'highcharts-vue';

	HighChart3D(HighChart);
	HighChartExporting(HighChart);

	export default {
		components: {
			ManagingSection,
			ManagingBox,
			Chart,
		},
		props: {
			newUserMap: {
				type: Object,
				default: () => ({}),
			},
			newReviewMap: {
				type: Object,
				default: () => ({}),
			},
			newReviewUserMap: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				chartOptions: {},
			};
		},
		mounted() {
			this.$nextTick(() => {
				this.setChart();
			});
		},
		watch: {
			newUserMap: 'setChart',
			newReviewMap: 'setChart',
			newReviewUserMap: 'setChart',
		},
		methods: {
			setChart() {
				if (
					Object.keys(this.newUserMap).length === 0 &&
					Object.keys(this.newReviewMap).length === 0 &&
					Object.keys(this.newReviewUserMap).length === 0
				) {
					console.warn('데이터가 없습니다');
					return;
				}

				this.$nextTick(() => {
					if (this.$refs.chart && this.$refs.chart.chart) {
						this.$refs.chart.chart.showLoading(
							'데이터를 읽고 있습니다'
						);
					}

					const newUserData = Object.keys(this.newUserMap).map(
						data => [data, this.newUserMap[data]]
					);
					const newReviewData = Object.keys(this.newReviewMap).map(
						data => [data, this.newReviewMap[data]]
					);
					const newReviewUserData = Object.keys(
						this.newReviewUserMap
					).map(data => [data, this.newReviewUserMap[data]]);

					const allDates = Array.from(
						new Set([
							...Object.keys(this.newUserMap),
							...Object.keys(this.newReviewMap),
							...Object.keys(this.newReviewUserMap),
						])
					).sort();

					this.chartOptions = {
						chart: {
							type: 'area',
							height: 450,
						},
						series: [
							{
								name: '일별 리뷰수',
								data: newReviewData,
							},
							{
								name: '리뷰 유저수',
								data: newReviewUserData,
							},
							{
								name: '회원 가입수',
								data: newUserData,
							},
						],
						title: { text: 'Glowpick Data' },
						xAxis: { categories: allDates },
						yAxis: { title: { text: 'Glowpick chart' } },
						tooltip: {
							formatter: function () {
								return (
									this.series.name +
									'<br/>' +
									this.x.replace(
										/(\d\d\d\d)(\d\d)(\d\d)/g,
										'$1-$2-$3'
									) +
									' : ' +
									'<b>' +
									this.y +
									'<b/>'
								);
							},
						},
						plotOptions: {
							area: {
								pointStart: 0,
								marker: {
									enabled: false,
									symbol: 'circle',
									radius: 2,
									states: { hover: { enabled: true } },
								},
							},
						},
					};

					if (this.$refs.chart && this.$refs.chart.chart) {
						this.$refs.chart.chart.hideLoading();
					}
				});
			},
		},
	};
</script>

<style lang="scss" scoped></style>
